import React from "react";
import "./ContactUs.css";
function ContactUs() {
  return (
    <div className="contact-us">
      <h1>Get in Touch</h1>
      <p>
        Reach out to us for tailored software solutions that enhance your
        business processes.
      </p>

      <div className="contact-section">
        <h2>General Enquiries</h2>
        <p>
          <strong>Phone:</strong> 020 8984 8815
        </p>
        <p>
          <strong>Email:</strong> info@nuqisoft.com
        </p>
      </div>

      <div className="contact-section">
        <h2>Office Address</h2>
        <p>Unit-14, Enterprise Business Centre, Consul Avenue, RM13 8JE</p>
      </div>
    </div>
  );
}

export default ContactUs;
